// Email notification pricing
// Sending an email costs 1/100th of a credit (0.01 credits)

const COST_PER_EMAIL_CREDITS = 0.01;

/**
 * Get the credit conversion rate for email notifications.
 * Returns the number of credits per email sent.
 */
export function getEmailConversionRate(): number {
    return COST_PER_EMAIL_CREDITS;
}
